// extracted by mini-css-extract-plugin
export var addButton = "_40-d";
export var bullets = "_40-e";
export var compact = "_40-2";
export var container = "_40-j";
export var extendedWarrantyModal = "_40-f";
export var learn = "_40-l";
export var learnMore = "_40-g";
export var offeringOption = "_40-3";
export var offeringPrice = "_40-8";
export var offeringSubtitle = "_40-7";
export var offeringTitle = "_40-6";
export var offeringsContainer = "_40-0";
export var pdpTilesBackground = "_40-n";
export var plan = "_40-m";
export var regular = "_40-1";
export var remove = "_40-k";
export var seeDetailsIcon = "_40-i";
export var seeDetailsLink = "_40-h";
export var selectedOption = "_40-4";
export var shieldIcon = "_40-b";
export var shieldIconCompact = "_40-c";
export var subtitle = "_40-a";
export var title = "_40-9";
export var unselectedOption = "_40-5";